<template>
  <div id="page-user-list">
    <div class="vx-card p-6 minus-top">
      <div  class="vx-col md:w-1/2  w-full mb-4">
        <span  class="title-page ml-6">{{$t('adminWs.title')}}</span>
      </div>
      <!-- <div class="flex-grow">
        <div style = "display:inline-block" class="vx-col md:w-1/6 sm:w-auto mr-4 ml-2">
          <label class="vs-input--label text-size">Trạng thái</label>
          <v-select class="text-size" v-model="processStatusModel" :clearable="false" :options="optionalProcessStatus"/>
        </div>
        <div class="mr-4"  style = "display: inline-block">
          <vs-button
            class="text-size"
            @click="getListWebsite"
            color="primary"
            type="border"
            icon-pack="feather"
            icon="">
            Lọc
          </vs-button>
        </div>
      </div> -->
      <div class="flex flex-wrap items-center mt-6 ml-4">
          <div class="vx-row ml-2">
               <vs-button
              class="text-size"
              color ="primary"
              type ="border"
              icon-pack ="feather"
              @click="addWebsite"
              >
                 {{$t('adminWs.addWs')}}
              </vs-button>
              <vs-button class="ml-2 text-size" @click="exportFileCSV" color ="success" type ="border" >{{$t('adminWs.formCSV')}}</vs-button>
              <vs-button class="ml-2 text-size" @click="importFile" color ="warning" type ="border" >{{$t('adminWs.importCSV')}}</vs-button>
          </div>
          <div class ="flex-grow"  >
          </div>
        <div class="my-4" style="margin-right: 150px;" >
          <span class="text-size"> <b>{{$t('adminWs.status')}}: </b> </span>
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" >
            <span v-if="labelStatus"><b style="color:#277DF6" class="text-size">{{labelStatus}}</b></span>
            <feather-icon icon ="ChevronDownIcon" style="vertical-align:middle;width:1rem" class=" color-text"> </feather-icon>
            <vs-dropdown-menu class="vx-navbar-dropdown" style="width:160px" :open="'left'" >
              <vs-dropdown-item @mousemove="backgroundHover">
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text" v-for="(item, keyStatus) in optionalProcessStatus" :key="keyStatus" @click="filterWebsiteByStatus(item)">
                  <span class="ml-2" style="vertical-align:middle;font-size: 12px">{{item.label}}</span>
                </li>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
          <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-2 text-size"
          :placeholder ="$t('adminWs.search')" v-on:keydown.enter="searchNameWebsite" v-model="searchWebsite.url" style="max-width: 200px;"
           />
      </div>
      <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        style="height:55vh"
        ref="agGridTable"
        :components ="components"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef = "defaultColDef"
        :rowData = "rowDatas"
        :animateRows = "true"
        :pagination = "true"
        :paginationPageSize ="20"
        :onGridReady ="onGridReady"
        :suppressPaginationPanel = "true"
        :per-page=perPage
      >
      </ag-grid-vue>
      <vs-pagination
      :total ="totalPages"
      :max="maxPageNumbers"
      v-model="currentPage"
      @change="onChangePage"
      ></vs-pagination>

  </div>
  <vs-popup title="Import file CSV" :active.sync="activeFile">
    <div class="vx-row">
      <div style="margin:auto">
    <div class="mb-8">
      <import-excel :onSuccess="loadDataInTable" />
        </div>
        <vx-card v-if="tableData.length && header.length">
          <vs-table stripe pagination :max-items="10" search :data="tableData" :noDataText="this.$t('noData')">
            <template slot="header">
              <h4>{{ sheetName }}</h4>
            </template>

            <template slot="thead">
              <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="col" v-for="(col, indexcol) in data[indextr]" :key="indexcol + col">
                  {{ col }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
      <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="border-radius ml-auto mt-2" icon="icon-plus" icon-pack="feather" @click="saveDataImport">{{$t('adminWs.save')}}
                </vs-button>
                <vs-button class="border-radius ml-4 mt-2" type="border" icon="icon-X" icon-pack="feather" @click="closePopup">{{$t('adminWs.closed')}}
                </vs-button>
              </div>
            </div>
          </div>
  </vs-popup>
  </div>
</template>
<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue"
import CellRendererIsPrivate from "./cell-renderer/CellRendererIsPrivate.vue"
import {AgGridVue} from "ag-grid-vue"
import vSelect from 'vue-select'

import ImportExcel from "@/components/excel/ImportExcel.vue"
export default {
  components:{
    AgGridVue,
    CellRendererActions,
    CellRendererStatus,
    CellRendererIsPrivate,
    vSelect,
    ImportExcel
  },
  data(){
    return {
      labelStatus: 'Tất cả',
      activeFile:false,
      tableData: [],
      header: [],
      sheetName: "",
      form :[
        {
         name: null,
         domain: null,
         config:null,
         categoryArticleId:null,
         type: null,
         url: '',
         status: "1"
        }
      ],
      maxPageNumbers:6,
      totalPages:0,
      perPage:10,
      gridApi:null,
      gridOptions:{},
      defaultColDef:{},
      gripApi:null,
      dataPagination:[],
      pageNumbers:0,
      pageSize:null,
      processStatus: null,
      optionalProcessStatus: [
        {label:'Tất cả',value:null},
        {label:'Đã tiếp nhận',value:0},
        {label:'Đã xử lý',value:1},
        {label:'Sẵn sàng',value:2},
        {label:'Đang rà quét',value:3}
      ],
      optionalGroup:[
        {text:'Báo chí',value:1},
        {text:'Tin tức',value:2},
        {text:'Blog', value:3},
        {text:'Forum', value:4}
      ],
      columnDefs:[
          {
            headerName:'ID',
            field:'id',
            width:100
          },
          {
            headerName:this.$t('adminWs.nameWs'),
            field:'name',
            width:100
          },
          {
            headerName:'Url',
            field:'url',
            width:100,
            cellRenderer: function(params){
              return `<a href="${params.data.url}" target="_blank" rel="noopener">${params.value || params.data.url}</a>`
            }
          },
          {
            headerName:this.$t('adminWs.group'),
            field:'type',
            width:100,
            cellRendererFramework: 'CellRendererIsPrivate'
          },
          {
            headerName: this.$t('adminWs.status'),
            field:'processStatus',
            width:50,
            cellRendererFramework:'CellRendererStatus'
          },
          {
            headerName:this.$t('adminWs.action'),
            field:'activeWebsite',
            width:50,
            cellRendererFramework: 'CellRendererActions'
          }
      ],
      components:{
        AgGridVue,
        CellRendererActions,
        CellRendererStatus,
        CellRendererIsPrivate
      },
      rowDatas:[],
      searchWebsite:{
          url:""
      },
      currentPage:1
    }
  },
  created(){
    this.initScreen();
    this.$eventBus.$on('i18n', (event) => {
      this.initScreen();
      this.checkWebsiteByStatus();
      this.columnDefs[1].headerName =  this.$t('adminWs.nameWs');
      this.columnDefs[3].headerName =  this.$t('adminWs.group');
      this.columnDefs[4].headerName =  this.$t('adminWs.status');
      this.columnDefs[5].headerName =  this.$t('adminWs.action');
      this.gridOptions.api.setColumnDefs(this.columnDefs);
    })
    this.checkWebsiteByStatus()

  },
  computed:{
    processStatusModel: {
      get() {
        return {
          label: this.optionalProcessStatus.find(x => x.value == this.processStatus).label,
          value: this.processStatus
        }
      },
      set(obj) {
        this.processStatus = obj.value;
      }
    }
  },
  watch:{
    '$store.state.windowWidth'(val) {
        if (val <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (val > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      '$store.state.reduceButton'() {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 650);
      },
      '$store.state.isUpdateUser'(val) {
        if (val) {
          this.initScreen();
          this.$store.commit('UPDATE_USER_SUCCESS', false);
        }
      },
  },
  methods:{
    backgroundHover: function(){
      document.getElementsByClassName('vs-component vs-dropdown--item')[0].style.background='#fff';
    },
    filterWebsiteByStatus: function(item){

        this.processStatus = item.value;
        if(!item.value && item.value != 0){
          this.labelStatus = this.$t('adminWs.all')
        }else{
          this.labelStatus = item.label;
        }
        this.getListWebsite();
    },
    checkWebsiteByStatus : function (){
      this.optionalProcessStatus[0].label = this.$t('adminWs.all')
      this.optionalProcessStatus[1].label = this.$t('adminWs.received')
      this.optionalProcessStatus[2].label = this.$t('adminWs.processed')
      this.optionalProcessStatus[3].label = this.$t('adminWs.ready')
      this.optionalProcessStatus[4].label = this.$t('adminWs.scanning')

    },
    closePopup: function(){
      this.activeFile = false;
      this.dataFile = [];
      this.tableData = [];
    },
    importFile:function(){
      this.activeFile = true;
      this.file = null;
    },
    loadDataInTable({ results, header, meta }) {
      this.header = header
      this.tableData = results
      this.sheetName = meta.sheetName
    },
    saveDataImport: function(){
        const header = this.header;
        const result = this.tableData;
        const payload = [];
        for(let c = 0; c < result.length; c++){
          if (isNaN(result[c][3].trim()) || ![1, 2, 3, 4].includes(parseInt(result[c][3].trim()))){
            return this.$vs.notify({
              text:this.$t('adminWs.textIllegal'),
              icon:'icon-alert',
              iconPack:'feather',
              color:'danger'
            })
          }
          let item = {
            name:result[c][1].trim(),
            url:result[c][2].trim(),
            type:result[c][3].trim(),
          }
          payload.push(item)
        }
        this.$processor.post(`website/create`, payload).then((response) =>{
          this.activeFile = false;
          this.dataFile = [];
          this.tableData = [];
          this.$vs.loading.close();
          this.getListWebsite()
          return this.$vs.notify({
            text:this.$t('adminWs.textSuccess'),
            icon:'icon-alert',
            iconPack:'feather',
            color:'primary'
          })
        }).
        catch((err) =>{
          this.$vs.loading.close();
          return this.$vs.notify({
               text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
        })
      },

      exportFileCSV: function(){
        const rows = [
            ["STT", "Website Name", "Url" , "Group ( 1 - Newspaper / 2 - News / 3 - Blog / 4 - Forum)"]
        ];
        let csvContent = "data:text/csv;charset=utf-8,";
        rows.forEach(function(rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
        });

        let data = encodeURI(csvContent);

        const filename = 'teamplate-import-website.csv';
        const link = document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('download', filename);
        link.click();
    },
    searchNameWebsite(){
      this.getListWebsite();
    },
    onGridReady(){
        if(this.$store.state.windowWidth <= 1024){
          this.maxPageNumbers = 5;
        }
        else{
          this.maxPageNumbers = 7;
        }
        if(this.$store.state.windowWidth > 1024){
          this.gridApi.sizeColumnsToFit();
        }
      },
    initScreen(){
        this.getListWebsite();
      this.labelStatus = this.$t('adminWs.all')
    },
    onChangePage(event){
      this.$vs.loading();
      const page = String(event);
      let payload ={
          pageNumber:parseInt(page) -1,
          pageSize:20,
          url: this.searchWebsite.url,
          processStatus: this.processStatus
      };
      this.$processor.post('/website/get-all',payload).then((response) =>{
        this.rowDatas = response.data.content;
        this.totalPages = parseInt(response.data.totalPages,10);
        // this.pageNumbers = response.data.pageable.pageNumber;
        this.$vs.loading.close();
      }).
      catch(() =>{
        this.$vs.loading.close();
      })
    },
    addWebsite(){
      this.$router.push('/page/website/add').catch(() =>{});
    },
    getListWebsite(){
      this.$vs.loading();
      let payload ={
          pageNumber:0,
          pageSize:20,
          url: this.searchWebsite.url,
          processStatus: this.processStatus
      };
      this.$processor.post('/website/get-all',payload).then((response) =>{
        this.rowDatas = response.data.content;
        this.totalPages = parseInt(response.data.totalPages,10);
        this.pagenumbers = response.data.pageable.pageNumber;
        this.$vs.loading.close();
      }).
      catch(() =>{})
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
}
</script>
<style scoped>
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}
.color-text{
  color: #626262;
}
.minus-top{
  margin-top: -24px;
}
</style>

